export default __webpack_public_path__ + "static/media/bell.2d9fc05a.svg";